var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MonitorLayoutTemplate", {
    attrs: { table_title: _vm.table_title },
    scopedSlots: _vm._u([
      {
        key: "datetime",
        fn: function() {
          return [
            _c("QpeDatetime", {
              attrs: {
                props_date: _vm.date,
                props_time: _vm.time,
                name: _vm.default_value
              },
              on: {
                "update-time": _vm.update_time,
                "change-parent-date-time": _vm.change_parent_date_time
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "description",
        fn: function() {
          return [_c("SignsCalculator", { attrs: { data: _vm.sign_data } })]
        },
        proxy: true
      },
      {
        key: "signs",
        fn: function() {
          return [
            _c("MonitorSigns", {
              attrs: {
                data: _vm.sign_data,
                hide_alert_remarks: true,
                is_show_raw_html: true,
                sort_type: "by_parent"
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "data_table",
        fn: function(slot_props) {
          return [
            _c("QpeDatatable", {
              staticClass: "lightning",
              attrs: {
                data: _vm.table_data,
                headers: _vm.header,
                name: _vm.default_value,
                error_text: _vm.error_text,
                props_date: _vm.date,
                props_time: _vm.time,
                search: slot_props.search,
                should_show_raw_html_header: _vm.should_show_raw_html_header,
                show_download_pdf_btn: true
              },
              on: {
                "update-time": _vm.update_time,
                "change-parent-date-time": _vm.change_parent_date_time
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "table_description",
                    fn: function() {
                      return [
                        _c("div", { staticClass: "option-description" }, [
                          _vm._v("\n                        燈號說明："),
                          _c("br"),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "description-dot",
                            staticStyle: { background: "#FF0000" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v(" 0-3km有閃電發生 ")]),
                          _c("br"),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "description-dot",
                            staticStyle: { background: "#FF9900" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v(" 3-8km有閃電發生 ")]),
                          _c("br"),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "description-dot",
                            staticStyle: { background: "#FFFF00" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v(" 8-16km有閃電發生 ")]),
                          _c("br"),
                          _vm._v(" "),
                          _c("span", [_vm._v("閃電資料來源：氣象署")])
                        ])
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                true
              )
            })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }